"use client";

// components/VegaEmbed.tsx
// framework-agnostic: ใช้ React.lazy แทน next/dynamic เพื่อให้ใช้ได้ทั้ง Next.js และ pure React (CRA)
// mounted-guard ทำหน้าที่แทน { ssr: false } เดิม เพื่อกันไม่ให้ vega-embed โหลดฝั่ง server
import { lazy, Suspense, useEffect, useState } from "react";

const VegaEmbedRoot = lazy(() => import("./VegaEmbedRoot"));

export default function VegaEmbed(props: any) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return (
    <Suspense fallback={null}>
      <VegaEmbedRoot {...props} />
    </Suspense>
  );
}
